// ============================================================================
// SessionsPage — routes /app/sessions, /app/sessions/:id (session log/detail)
// and the schedule entry point /app/sessions?client=:id  (namespace: "sessions")
// ----------------------------------------------------------------------------
// Plan, log and review training sessions:
//   • /app/sessions            — trainer-wide agenda of sessions; the `?client=`
//     query pre-scopes the schedule form to one client.
//   • /app/sessions/:id        — the SESSION LOG: sets, cardio, RPE, computed
//     volume/calories, plus apply-template.
// Data flows through the typed React Query hooks (useCalendar /
// useClientSessions / useSession / useCreateSession / useUpdateSession /
// useDeleteSession / useAddSet / useAddCardio / useApplyTemplate); the
// AppShell's live-sync socket invalidates qk.sessions.* (incl. set/cardio
// events) so the log stays fresh across devices.
//
// This file stays a DEFAULT export named SessionsPage and reads :id / ?client=
// from the URL, delegating to SessionsList or SessionLog. All UI is built on the
// locked Pulse design system; the "sessions" i18n namespace is owned here.
// ============================================================================
import { useParams, useSearchParams } from "react-router-dom";
import { SessionsList } from "./SessionsList";
import { SessionLog } from "./SessionLog";

export default function SessionsPage() {
  const params = useParams<{ id?: string }>();
  const [searchParams] = useSearchParams();

  // Session log/detail view when the route carries a valid :id.
  if (params.id != null) {
    const id = Number(params.id);
    if (Number.isFinite(id) && id > 0) {
      return <SessionLog key={id} sessionId={id} />;
    }
  }

  // Otherwise the agenda/list, optionally pre-scoped to a client via ?client=.
  const raw = searchParams.get("client");
  const clientParam = raw != null && /^\d+$/.test(raw) ? Number(raw) : null;

  return <SessionsList clientParam={clientParam} />;
}
